/***
 * README:
 * Module 31 is the "Reading Comprehension Template" 
 * For more example. please check this yotube:
 * https://www.youtube.com/watch?v=Y4ktCG2ByKw
 * That youtube video is also embedded in app as a preview.
 *  */


import React from 'react'
import Textarea from '../fields/textarea'
import Input from '../fields/input'


const Module31Form = (props) => {
    const {
        data
    } = props

    return <>
        <td>
            <Input
                label='Title'
                name="title"
                placeholder='Type your title'
                wlength={50} />
            <Textarea
                initialValue={data != null ? data.question_object.passage : ''}
                rows='12'
                label='Passage'
                name="passage"
                required
                placeholder='Type your passage'
                useWordAsCount={true}
                wlength={1500} />
        </td>
        <td>
            <Textarea
                label={`Question`}
                name="question"
                required
                placeholder='Type here'
                wlength={200} />
            <Input
                label='Correct answer'
                name="answer"
                required
                placeholder='Type your correct answer'
                wlength={150} />
            <label style={{ color: 'red' }}>Wrong Answer*</label>
            <Input
                name="wrong1"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                name="wrong2"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
            <Input
                name="wrong3"
                required
                placeholder='Type your wrong answer'
                wlength={150} />
        </td>
    </>
}


export default Module31Form

